export default __webpack_public_path__ + "static/KV_AD_8915_rgb-a69521d3476b10c03aa0d7ee8edb5051.jpg";